/**
* @author ZhanFuzheng
* @date 2022/07/14
* @time 16:13
*/
<template>
<div>
    <div id="wrapper">
        <!--头部-->
        <template v-if="!H5 && headVisible !== '0'">
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main" >科三灯光仿真训练</div>
                <div class="header-share" v-if="shareVisible" @click="openSharePanel"><img src="@/assets/public/icon_fx01.png" alt=""></div>
                <div class="header-right" v-if="!H5" @click="pushCusService"><img src="@/assets/vip/icon_customerservice1.png" alt=""></div>
            </div>
            <!--头部占位-->
            <div class="header-pre"></div>
        </template>
        <div class="detail">
            <img class="detail-image" src="@/assets/goods_old/picture_ksdgfz01.png" />
            <img class="detail-image" src="@/assets/goods_old/picture_ksdgfz02.png" />
            <div class="loop-image">
                <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
                    <van-swipe-item v-for="(item, index) in loopImages" :key="index" @click="preview(index)"><img class="detail-image" :src="item" /></van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <!--底部-->
        <div class="footer">
            <div class="price">¥0<span>原价￥88</span></div>
            <van-button @click="handleToLightingRealistic">立即体验</van-button>
        </div>
        <!--底部占位-->
        <div class="footer-pre"></div>
    </div>
</div>
</template>
<script>
import { Button, Swipe, SwipeItem, ImagePreview } from 'vant'
export default {
    name: 'goodsLightDetail',
    components: {
        [Button.name]: Button,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem
    },
    data () {
        return {
            // 分享数据
            shareData: {},
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            loopImages: [require('../../assets/goods_old/picture_slt01.png'), require('../../assets/goods_old/picture_slt02.png'), require('../../assets/goods_old/picture_slt03.png'), require('../../assets/goods_old/picture_slt04.png'), require('../../assets/goods_old/picture_slt05.png')]
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 联系客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || '科三灯光仿真训练'
            // 内容
            let content = '快来体验科三灯光仿真训练，轻松高效只要有手就会！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'light-detail'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/icon_ksdgmn.png'
            }

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'light-detail' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 初始化
        init () {
            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_detail_visit' })
            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'
            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)
            // 设置分享显示
            this.shareVisible = !this.H5
            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 跳转
        handleToLightingRealistic () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }
            // 点击灯光立即体验按钮 触发埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_pay_click' })
            // 如果是安卓的客户端
            if (!this.IOS) {
                // 获取json信息
                const jsonStr = this.$jsBridge.callBackHandler('passTokenData')
                // 没有token 就去登录
                if (!JSON.parse(jsonStr).token) {
                    this.$jsBridge.callBackHandler('loginUserV2')
                    return
                }
            }
            // 跳转到 灯光仿真操作页面
            this.$jsBridge.callBackHandler('pushLightingRealisticPage')
        },
        // 图片预览
        preview (index) {
            ImagePreview({
                images: this.loopImages,
                startPosition: index
            })
        }
    },
    mounted () {
        this.init()
        this.getSetting()
    }
}
</script>
<style lang="scss" scoped>
    #wrapper{
        height: 100%;
        background-color: #feecde;
    }
    .header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        z-index: 2;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        background: #ffffff;
        .header-main {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            line-height: 1;
            transform: translateY(3px);
        }
        .header-share {
            position: absolute;
            height: 44px;
            display: flex;
            align-items: center;
            right: 50px;
            font-size: 0;
            line-height: 1;
            img {
                width: 24px;
            }
        }
        .header-left, .header-right {
            display: flex;
            padding: 0 10px;
            font-size: 0;
            line-height: 1;
            img {
                width: 24px;
                height: 24px;
            }
        }
    }
    .header-pre {
        height: 44px;
    }
    .footer{
        display: flex;
        align-items: center;
        z-index: 2;
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #ffffff;
        .price{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            color: #FF5050;
            font-size: 24px;
            line-height: 20px;
            span{
                margin-left: 5px;
                color: #999999;
                font-weight: normal;
                font-size: 15px;
                text-decoration: line-through;
            }
        }
        /deep/ .van-button {
            border: none;
            height: 49px;
            width: 120px;
            color:#A86F2F;
            background-color: #F5DDB6;
            font-size: 18px;
            font-weight: bold;
            border-radius: 0;
        }
    }
    .footer-pre {
        height: 49px;
    }
    .detail{
        position: relative;
        &-image{
            width: 100%;
            vertical-align: middle;
        }
        .loop-image{
            position: absolute;
            top: 346px;
            left:50%;
            transform: translateX(-50%);
            width: 325px;
            height: 183px;
        }
        /deep/ .van-swipe__indicator{
            width: 3px;
            height: 3px;
        }
        /deep/ .van-swipe__indicator--active {
            width: 6px;
            border-radius: 2px;
        }
        /deep/ .van-swipe__indicator:not(:last-child){
            margin-right: 3px;
        }
    }

</style>
